//Auth
export const SltLoginUrl = '/auth/slt'
export const StartUrl = '/auth/start'
export const LoginUrl = '/auth/login'
export const SignupUrl = '/auth/signup'
export const SSOUrl = '/auth/sso'
export const SamlLoginUrl = '/auth/saml_landing'
export const SamlMobileAppRedirect = 'everlance://sso_success?jwt=:jwt'
export const SamlPurpleMobileAppRedirect =
  'motus-reimburse://sso_success?jwt=:jwt'
export const SendPasswordResetUrl = '/password_resets/new'
export const PasswordResetUrl = '/password_resets/:id/edit'

// Purple incorrect app login
export const IncorrectAppMotusUrl = '/auth/incorrect_app/motus'
export const IncorrectAppEverlanceUrl = '/auth/incorrect_app/everlance'

// Purple new experience
export const NewExperienceUrl = '/auth/new_experience'

// Purple road smart
export const RoadSmartUrl = '/road-smart'
// Misc
export const SplashMessageUrl = '/splash_message'
export const AcceptInviteUrl = '/accept-invite'
export const FreshbooksUrl = '/auth-freshbooks'
export const ManageSubscriptionsUrl = '/manage_email_subscriptions/:token_id'
export const PremiumUrl = '/premium'
export const TeamsFeatureUrl = '/teams-features'
export const MaintenanceUrl = '/maintenance'

// Sign up flow
export const SignUpAboutYouUrl = '/about-you'
export const SignUpStepOneUrl = '/step-one'
export const SignUpStepTwoUrl = '/step-two'
export const SignUpStepThreeUrl = '/step-three'
export const UnlimitedTripsUrl = '/unlimited-trips'
export const SignUpCreateTeamUrl = '/create-team'
export const SignUpInviteUrl = '/invite-members'

// Home
export const DashboardUrl = '/dashboard'

//Transactions
export const TransactionsUrl = '/transactions'

//Trips
export const TripsUrl = '/trips'
// Data exports
export const DataExportsUrl = '/data-exports'

//Reports
export const ReportsUrl = '/reports'
export const ReportDetailUrl = '/reports/:report_id'
export const SharedReportUrl = '/shared/report/:report_id'

// Compliance
export const ComplianceOverviewUrl = '/compliance'
// IMPORTANT NOTE: Do not change this URL without notifying mobile team
export const ComplianceUrl = '/compliance/driver-form'

// MVR
export const MvrOverviewUrl = '/mvr'

// Tax info
export const TaxInfoUrl = '/taxes'

//Account

export const AccountUrl = '/account'
export const AccountProfileUrl = '/account/profile'
export const AccountPerksUrl = '/account/perk'
export const AccountInsuranceUrl = '/account/insurance'
export const AccountPremiumUrl = '/account/premium'
export const AccountPurposesUrl = '/account/purposes'
export const AccountTrackerUrl = '/account/tracker'
export const AccountFavoriteTripsUrl = '/account/favorite-trips'
export const AccountFavoritePlacesUrl = '/account/favorite-places'
export const AccountTaxCenterUrl = '/account/tax-center'
export const AccountWorkHoursUrl = '/account/work-hours'
export const AccountVehiclesUrl = '/account/vehicles'
export const AccountBankCardUrl = '/account/bank-card'
export const AccountDirectDepositUrl = '/account/direct-deposit'
export const AccountFavoriteTransactionsUrl = '/account/favorite-transactions'
export const AccountImporterUrl = '/account/importer'
export const AccountTeamUrl = '/account/team'

/******** Team ********/

export const TeamDashboardUrl = '/teams'

//Reports
export const TeamReportsUrl = '/teams/reports'
export const TeamReportDetailUrl = '/team/:team_id/report/:report_id'

// Members
export const TeamMembersUrl = '/teams/members'
export const MemberInviteUrl = '/teams/members/new'

// Data export
export const TeamDataExportUrl = '/teams/data-exports'

// Compliance
export const TeamComplianceUrl = '/teams/compliance'
export const TeamComplianceDetailUrl = '/teams/compliance/:token_id'

//Schedules
export const SchedulesUrl = '/team/:token_id/schedules'
export const ScheduleDetailUrl = '/team/:token_id/schedules/:id'

//Pay Periods
export const PayPeriodsUrl = '/teams/reimbursements'
export const PayPeriodDetailUrl = '/teams/reimbursements/pay-periods/:token_id'

//Summary
export const TeamSummaryUrl = '/teams/summary'

//Premium
export const TeamPremiumUrl = '/teams/premium'

//Teams
export const TeamsUrl = '/teams/all'

//Accountants
export const AccountantsUrl = '/accountants'

//Team settings
export const TeamProfileUrl = '/team/:token_id/profile'
export const TeamPreferencesUrl = '/team/:token_id/account-preferences'
export const TeamCategoriesUrl = '/team/:token_id/categories'
export const TeamPlacesUrl = '/team/:token_id/places'
export const TeamRolesUrl = '/team/:token_id/roles'
export const TeamProgramsUrl = '/team/:token_id/programs'
export const TeamTagsUrl = '/team/:token_id/tags'
export const TeamSettingsPaymentsUrl = '/team/:token_id/payments'
export const TeamProgramDetailUrl = '/team/:token_id/program/:program_id'
export const TeamProgramPurposesUrl =
  '/team/:token_id/program/:program_id/purposes'
export const TeamAutomationsUrl = '/team/:token_id/automations'
export const TeamIntegrationsUrl = '/team/:token_id/integrations'
export const TeamSingleSignOnUrl = '/team/:token_id/integrations/sso'
export const TeamMergeUrl = '/team/:token_id/integrations/merge'
export const TeamMergeConfigUrl =
  '/team/:token_id/integrations/merge/:id/configure'
export const TeamMergeConfigImportMembersUrl =
  '/team/:token_id/integrations/merge/:id/configure/import-members'
export const TeamMergeConfigUserFieldsUrl =
  '/team/:token_id/integrations/merge/:id/configure/user-fields'
export const TeamMergeConfigTeamHierarchyUrl =
  '/team/:token_id/integrations/merge/:id/configure/team-hierarchy'

//Payments
export const TeamWalletUrl = '/teams/wallet'
export const TeamFboWalletUrl = '/teams/wallet/fbo'

// Motus User Portal
export const ComplianceForm = '/forms/details'
export const DirectDepositForm = '/forms/directDeposit'
